const getUpdatedQuery = (filter) => {
  const selectedItems = filter.selectedItems || [];

  if (selectedItems.length === 0) {
    return { [filter.id]: undefined };
  }

  return { [filter.id]: selectedItems[0] };
};

const update = (filter, query) => {
  const queryValue = query[filter.id];

  const selectedItems = queryValue ? [queryValue] : [];

  return {
    ...filter,
    selectedItems,
  };
};

const clear = (filter) => {
  return {
    ...filter,
    selectedItems: [],
  };
};

const clearGroup = (filters, id) => {
  return filters.map((filter) => {
    if (filter.id === id) {
      return clear(filter);
    }

    return filter;
  });
};

const count = (filter) => {
  return filter.selectedItems?.length > 0 ? 1 : 0;
};

const handleSelectionChange = (filter, { selectedItems }) => {
  const radioSelectedItems = selectedItems.length > 0 ? [selectedItems[0]] : [];

  return {
    ...filter,
    selectedItems: radioSelectedItems,
  };
};

export const radioBtnFilterHelper = {
  getUpdatedQuery,
  update,
  clear,
  clearGroup,
  count,
  handleSelectionChange,
};
